import React, { useState, useEffect } from 'react';
import { TextField, Checkbox, FormControlLabel, FormGroup, Typography, Grid, Paper } from '@mui/material';

const BuildingProtectionOccupancyFormFields = ({ data, sectionState = {}, onSectionSubmit }) => {
    const [localFormData, setLocalFormData] = useState({});

    useEffect(() => {
        // Initialize local form data based on sectionState and data
        const initialData = {};
        data.forEach(field => {
            initialData[field.Key] = sectionState[field.Key] ?? field.DefaultValue;
        });
        setLocalFormData(initialData);
    }, [data, sectionState]);

    const handleLocalChange = (key, value) => {
        const updatedData = { ...localFormData, [key]: value };
        setLocalFormData(updatedData);
        onSectionSubmit(updatedData); // Notify parent of the updated state
    };

    return (
        <>
            {/* <Typography variant="h6" gutterBottom>Building Protection</Typography> */}
            <Grid container spacing={2}>
                {data.map(field => {
                    const { Key, DisplayName, Type } = field;

                    if (Type === 'bool') {
                        return (
                            <Grid item xs={12} sm={12} key={Key}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={localFormData[Key] || false}
                                            onChange={(e) => handleLocalChange(Key, e.target.checked)}
                                        />
                                    }
                                    label={DisplayName}
                                />
                            </Grid>
                        );
                    }

                    if (Type === 'float') {
                        return (
                            <Grid item xs={12} sm={3} key={Key}>
                                <TextField
                                    fullWidth
                                    type="number"
                                    label={DisplayName}
                                    value={localFormData[Key] || ''}
                                    onChange={(e) => handleLocalChange(Key, parseFloat(e.target.value))}
                                />
                            </Grid>
                        );
                    }

                    return null;
                })}
            </Grid>
        </>
    );
};

export default BuildingProtectionOccupancyFormFields;